var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUpArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 20,
    width: 20,
    height: 20,
    rx: 2,
    transform: "rotate(90 20 0)",
    fill: "#D1DBCF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.9996 9.40831L12.9496 12.3583C13.1057 12.5135 13.3169 12.6006 13.5371 12.6006C13.7573 12.6006 13.9685 12.5135 14.1246 12.3583C14.2027 12.2808 14.2647 12.1887 14.307 12.0871C14.3493 11.9856 14.3711 11.8766 14.3711 11.7666C14.3711 11.6566 14.3493 11.5477 14.307 11.4462C14.2647 11.3446 14.2027 11.2524 14.1246 11.175L10.5913 7.64164C10.5138 7.56353 10.4216 7.50154 10.3201 7.45923C10.2185 7.41692 10.1096 7.39514 9.9996 7.39514C9.88959 7.39514 9.78066 7.41692 9.67912 7.45923C9.57757 7.50154 9.4854 7.56353 9.40793 7.64164L5.83293 11.175C5.7557 11.2528 5.69459 11.3452 5.65312 11.4467C5.61165 11.5482 5.59063 11.657 5.59126 11.7666C5.59063 11.8763 5.61165 11.985 5.65312 12.0866C5.69459 12.1881 5.7557 12.2804 5.83293 12.3583C5.98907 12.5135 6.20027 12.6006 6.42043 12.6006C6.64058 12.6006 6.85179 12.5135 7.00793 12.3583L9.9996 9.40831Z",
    fill: "#2D5B30"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpArrow);
export default __webpack_public_path__ + "static/media/up-arrow.0282050768c9fd6667b31277ec9df39e.svg";
export { ForwardRef as ReactComponent };